@if (headerInfo() && showHeader()) {
  <div class="[ cluster ]">
    <div class="[ items-start ]">
      @if (headerInfo().logo) {
        <img class="[ icon-size-3xl ]" [src]="headerInfo().logo | assetsPath: 'images' : 'illustrations'" />
      }
      <div class="[ stack stack-space-3xs ] [ flex-1 ]">
        <div class="[ title-large ]">{{ headerInfo().strandName }}</div>
        @if (headerInfo().methodName || headerInfo().surveyAnswers?.length) {
          <div class="[ title-medium ]">
            <span>{{ headerInfo().methodName }}</span>
            @if (headerInfo().surveyAnswers?.length) {
              <span class="[ label-medium ]">
                Gestart als
                <strong>{{ headerInfo().surveyAnswers.join(' - ') }}</strong>
              </span>
            }
          </div>
        }
      </div>
    </div>
  </div>
}

<div class="[ stack stack-space-2xl overflow-x-auto ]">
  @for (concept of concepts(); track $index) {
    <table class="[ table w-full ] [ surface text-left ]">
      <tr>
        <th [attr.colspan]="useLevelIndicator() ? 8 : 7">
          <div
            class="[ p-b-2xs p-is-l p-ie-2xs ] [ title-medium truncate ] [ corner-top-m corner-bottom-xs ]"
            [ngClass]="concept.resultsWithActions && concept.resultsWithActions.length > 0 ? 'secondary-container' : 'surface-variant'"
          >
            {{ concept.name }}
          </div>
        </th>
      </tr>
      @if (concept.resultsWithActions && concept.resultsWithActions.length > 0) {
        <tr class="[ label-medium white-space-nowrap opacity-medium ]">
          <th class="[ w-0 p-i-2xs p-bs-2xs ]"></th>
          @if (useLevelIndicator()) {
            <th class="[ w-0 p-i-2xs p-bs-2xs ]"></th>
          }
          <th class="[ p-i-2xs p-bs-2xs min-w-3xs ]">Titel</th>
          <th class="[ w-0 p-i-2xs p-bs-2xs ]">Score</th>
          <th class="[ w-0 p-i-2xs p-bs-2xs ]"></th>
          <th class="[ w-0 p-i-xs p-bs-2xs ]">Tijd</th>
          <th class="[ w-0 p-i-xs p-bs-2xs ]">Ingediend op</th>
          <th class="[ w-0 p-i-2xs p-bs-2xs ]"></th>
        </tr>
        @for (resultWithActions of concept.resultsWithActions; track $index) {
          <tr class="[ border-be last:border-none hover:background ] [ transition-colors ]">
            @if (resultWithActions.result; as result) {
              @if (result.eduContent) {
                <td class="[ p-b-s p-i-2xs ]"><campus-icon [svgIcon]="EduContent.toEduContent(result.eduContent).icon"></campus-icon></td>
                @if (useLevelIndicator()) {
                  <td class="[ p-b-s p-i-2xs ]">
                    @if (result.eduContent.level) {
                      <campus-level-indicator
                        [levels]="levels()"
                        [active]="result.eduContent.level"
                        class="[ icon-size-s ]"
                      ></campus-level-indicator>
                    }
                  </td>
                }
                <td class="[ p-b-s p-i-2xs ]">
                  <div class="[ stack stack-space-3xs ]">
                    @if (!useLevelIndicator() && result.eduContent.level) {
                      <span class="[ label-overline ]">
                        {{ result.eduContent.level.name }}
                      </span>
                    }
                    <span class="[ label-large line-clamp-2 ]">
                      {{ result.eduContent.publishedEduContentMetadata.title }}
                    </span>
                  </div>
                </td>
                <td class="[ p-b-s p-i-2xs ]"><campus-score [result]="result"></campus-score></td>
                <td class="[ p-b-s p-i-2xs ]">
                  @if (showStars && result.eduContent.isScorable) {
                    <campus-rating class="[ white-space-nowrap ]" [total]="3" [count]="result.stars"></campus-rating>
                  }
                </td>
                <td class="[ p-b-s p-i-xs ]">
                  @if (result.time) {
                    <div class="[ body-small white-space-nowrap ]">
                      {{ result.time | time: true }}
                    </div>
                  }
                </td>
                <td class="[ p-b-s p-i-xs ]">
                  <div class="[ body-small ]">
                    {{ result.lastUpdated | humanDateTime: { format: 'shortDateTime' } }}
                  </div>
                </td>
                <td class="[ p-b-s p-i-2xs ]">
                  @if (result.eduContent.type !== 'drill') {
                    <div>
                      @for (action of resultWithActions.actions; track $index) {
                        <button
                          inline-icon-button
                          (click)="handleEduContentAction(action, result)"
                          [matTooltip]="action.tooltip"
                          icon="preview"
                        ></button>
                      }
                    </div>
                  }
                </td>
              }
            }
          </tr>
        }
      } @else {
        <tr class="[ label-medium opacity-medium ]">
          <td class="[ p-i-2xs p-bs-2xs ] [ text-center ]">
            {{ headerInfo().studentDisplayName ? headerInfo().studentDisplayName + ' heeft' : 'Je hebt' }}
            nog niet geoefend aan
            <strong>"{{ concept.name }}".</strong>
          </td>
        </tr>
      }
    </table>
  }
</div>
